import { FC } from 'react';
import './TourEscapeHatch.scss';

export interface ITourEscapeHatchProps {
    onExit: () => void;
}

/**
 * Полупрозрачная кнопка в правом нижнем углу экрана — позволяет принудительно
 * закрыть тур, если он завис (например, action-шаг ждёт таргет, который не появится).
 * Рендерится поверх overlay (zIndex > 10000) и всегда кликабельна.
 */
const TourEscapeHatch: FC<ITourEscapeHatchProps> = ({ onExit }) => {
    return (
        <button
            type="button"
            className="tour-escape-hatch"
            onClick={onExit}
            title="Завершить обучающий тур"
            data-testid="tour-escape-hatch"
        >
            Завершить тур
        </button>
    );
};

export default TourEscapeHatch;
